export default "__VITE_ASSET__6022fdb5__"